export function parseProductQuestionId(questionId: string) {
  if (!/^[1-9]\d*$/.test(questionId)) {
    return null
  }

  const parsed = Number.parseInt(questionId, 10)

  return Number.isSafeInteger(parsed) ? parsed : null
}
